.root {
	padding-top: 80px;
	padding-bottom: 80px;
}

.title {
	font-weight: 500;
	font-size: rem(34px);
	margin-bottom: var(--mantine-spacing-md);

	@media (max-width: $mantine-breakpoint-sm) {
		font-size: rem(32px);
	}
}

.control {
	@media (max-width: $mantine-breakpoint-sm) {
		width: 100%;
	}
}

.mobileImage {
	@media (min-width: $mantine-breakpoint-sm) {
		display: none;
	}
}

.desktopImage {
	@media (max-width: $mantine-breakpoint-sm) {
		display: none;
	}
}
